import * as React from "react"
import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/ui/sidebar"

export function TeamSwitcher() {
    const { state } = useSidebar()


    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <SidebarMenuButton
                    size="lg"
                    className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground min-w-full"
                >
                    {state === "collapsed" ? (
                        <div className="flex aspect-square items-center justify-center rounded-lg text-sidebar-primary-foreground min-w-full">
                            <img
                                src={`${process.env.PUBLIC_URL}/logo.png`}
                                alt="Logo"
                                width={195}
                            />
                        </div>
                    ) : (
                        <div className="flex aspect-square size-20 items-center justify-center rounded-lg text-sidebar-primary-foreground">
                            <img
                                src={`${process.env.PUBLIC_URL}/logo-with-text.png`}
                                alt="Logo"
                                width="195"
                            />
                        </div>
                    )}
                </SidebarMenuButton>
            </SidebarMenuItem>
        </SidebarMenu>
    )
}
